import { instance } from '@/services/avik-api-gateway'
import { VehicleWithdrawalResponsible } from '@/types/vehicle-withdrawal-responsible'
import { AxiosResponse } from 'axios'

export function createVehicleWithdrawalResponsible(
  body: Partial<VehicleWithdrawalResponsible>
): Promise<AxiosResponse<VehicleWithdrawalResponsible>> {
  return instance.post(`/vehicle-withdrawal-responsible`, body)
}
